import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function ForYouSection() {
  return <section className="py-20 px-4 bg-cream" data-id="element-57">
      <div className="max-w-5xl mx-auto" data-id="element-58">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-59">
          {/* Para ti */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-warm border-t-8 border-sage" data-id="element-60">
            <h2 className="text-3xl font-bold mb-8 text-sage" data-id="element-61">
              ESTO ES PARA TI SI:
            </h2>
            <ul className="space-y-6" data-id="element-62">
              {['Eres una mujer hispana de 60 años o más viviendo en EE. UU.', 'Sufres de dolores articulares, pesadez abdominal o falta de energía al despertar.', 'Extrañas tu comida típica pero te da miedo que te suba el azúcar o la inflamación.', 'Quieres una solución práctica, en español y con ingredientes que consigues a la vuelta de tu casa.'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-63">
                  <CheckCircle2Icon className="w-6 h-6 text-sage shrink-0 mt-1" data-id="element-64" />
                  <span className="text-lg" data-id="element-65">{text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white/50 p-8 md:p-10 rounded-3xl border-t-8 border-terracotta" data-id="element-66">
            <h2 className="text-3xl font-bold mb-8 text-terracotta" data-id="element-67">
              ESTO NO ES PARA TI SI:
            </h2>
            <ul className="space-y-6" data-id="element-68">
              {['Buscas dietas extremas de gimnasio para perder 10 kilos en una semana.', 'No estás dispuesta a cambiar tu marca de harina por una más saludable.', 'Prefieres seguir tomando medicamentos para la acidez en lugar de cambiar lo que pones en tu plato.'].map((text, i) => <li key={i} className="flex items-start gap-4 text-espresso/70" data-id="element-69">
                  <XCircleIcon className="w-6 h-6 text-terracotta shrink-0 mt-1" data-id="element-70" />
                  <span className="text-lg" data-id="element-71">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}